/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type VerifyGcpIamPlatformCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type VerifyGcpIamPlatformCredentialRequest = {
  /**
   * The ID of the credential to verify.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type VerifyGcpIamPlatformCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyGcpIamPlatformCredentialSecurity$outboundSchema:
  z.ZodMiniType<
    VerifyGcpIamPlatformCredentialSecurity$Outbound,
    VerifyGcpIamPlatformCredentialSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function verifyGcpIamPlatformCredentialSecurityToJSON(
  verifyGcpIamPlatformCredentialSecurity:
    VerifyGcpIamPlatformCredentialSecurity,
): string {
  return JSON.stringify(
    VerifyGcpIamPlatformCredentialSecurity$outboundSchema.parse(
      verifyGcpIamPlatformCredentialSecurity,
    ),
  );
}

/** @internal */
export type VerifyGcpIamPlatformCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyGcpIamPlatformCredentialRequest$outboundSchema:
  z.ZodMiniType<
    VerifyGcpIamPlatformCredentialRequest$Outbound,
    VerifyGcpIamPlatformCredentialRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function verifyGcpIamPlatformCredentialRequestToJSON(
  verifyGcpIamPlatformCredentialRequest: VerifyGcpIamPlatformCredentialRequest,
): string {
  return JSON.stringify(
    VerifyGcpIamPlatformCredentialRequest$outboundSchema.parse(
      verifyGcpIamPlatformCredentialRequest,
    ),
  );
}
